import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=0b0d2312&"
import script from "./loading.ts?vue&type=script&lang=js&"
export * from "./loading.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports